import {AppBlock} from "@ok/web/modules/block/AppBlock";
import {ToastManagerStore} from "./ToastManagerStore";
import {ToastManager} from "../components/ToastManager/ToastManager";
import {ToastManagerController} from "./ToastManagerController";
import {IToastManagerAttrs} from "./ToastManagerAttrs";

export class ToastManagerBlock extends AppBlock<IToastManagerAttrs, {}, ToastManagerStore, ToastManagerController> {
    getAppAPI() {
        return {};
    }

    getAppEntities() {
        return {
            Store: ToastManagerStore,
            Controller: ToastManagerController,
            Component: ToastManager
        };
    }
}
